module.exports = __webpack_public_path__ + "static/media/banquet-table-misc-food.11a50c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/banquet-table-misc-food.jpg
// module id = 823
// module chunks = 0